import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import StatisticsByDayTable from './StatisticsByDayTable.js';
import {
    mainSelector,
    getHeaderName,
    getMetrics,
    getKeysMetric,
    getRowsCount
} from './StatisticsByDayTable.selectors';

const mapStateToPropsSelectors = createStructuredSelector({
    data: mainSelector,
    headerName: getHeaderName,
    metrics: getMetrics,
    keysMetric: getKeysMetric,
    rowsCount: getRowsCount
});

const StatisticsByDayTableComponent = connect(
    function mapStateToProps(state) {
        return {
            ...mapStateToPropsSelectors(state),
            loading: state.statistics.data.loading
        };
    },
    function mapDispatchToProps(dispatch) {
        return {
        };
    }
)(StatisticsByDayTable);

export default StatisticsByDayTableComponent;
